import React from "react";

import { Button } from "react-bootstrap";
import { CancelIcon, TicketIcon } from "../gui_components/Icons.js";
import { Printer, List, Receipt, Ship, RefreshCw, MailCheck, FileSpreadsheet, Truck } from "lucide-react";

export class PickTicketModuleToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowCancelButton: this.props.isShowCancelButton,
      isShowGenerateInvoiceButton: this.props.isShowGenerateInvoiceButton,
      isShowPrintLabelButton: this.props.isShowPrintLabelButton,
      isShowSyncButton: this.props.isShowSyncButton,
      isShowShippingButton: this.props.isShowShippingButton,
      isShowPackingListButton: this.props.isShowPackingListButton,
      isShowMailPackingButton: this.props.isShowMailPackingButton,
      isShowExcelPackingButton: this.props.isShowExcelPackingButton,
      isShowUpdateInvoiceButton: this.props.isShowUpdateInvoiceButton,
      isShowProformaInvoiceButton: this.props.isShowProformaInvoiceButton,
    };
  }
  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  cancelPickTicket = (e) => {
    if (e.detail === 1) this.props.cancelPickTicket();
  };

  generateInvoice = (e) => {
    if (e.detail === 1) this.props.generateInvoice();
  };

  updateExistingInvoice = (e) => {
    if (e.detail === 1) this.props.updateExistingInvoice();
  };

  generatePrintLabel = (e) => {
    if (e.detail === 1) this.props.generatePrintLabel();
  };

  generatePackingList = (e) => {
    if (e.detail === 1) this.props.generatePackingList();
  };
  generateBol = (e) => {
    if (e.detail === 1) this.props.generateBol();
  };
  generateSync = (e) => {
    if (e.detail === 1) this.props.generateSync();
  };
  mailPacking = (e) => {
    if (e.detail === 1) this.props.mailPacking();
  };
  excelPacking = (e) => {
    if (e.detail === 1) this.props.excelPacking();
  };
  shippingPickTicket = (e) => {
    if (e.detail === 1) this.props.shippingPickTicket();
  };
  generateProformaInvoice = (e) => {
    if (e.detail === 1) this.props.generateProformaInvoice();
  };
  render() {
    return (
      <>
        {this.props.isShowCancelButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.cancelPickTicket(e)}
          >
            <CancelIcon />
            Cancel
          </Button>
        )}
        {this.props.isShowGenerateInvoiceButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generateInvoice(e)}
          >
            <TicketIcon />
            Invoice
          </Button>
        )}
        {this.props.isShowUpdateInvoiceButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.updateExistingInvoice(e)}
          >
            <TicketIcon />
            Invoice+
          </Button>
        )}
        {this.props.isShowPrintLabelButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generatePrintLabel(e)}
          >
            <Printer size={16} />
            Print Label
          </Button>
        )}
        {this.props.isShowPackingListButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generatePackingList(e)}
          ><List size={16} />
            Packing List
          </Button>
        )}
        {this.props.isShowProformaInvoiceButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generateProformaInvoice(e)}
          >
            <Receipt size={16} />
            Proforma Invoice
          </Button>
        )}
        {this.props.isShowBOLButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generateBol(e)}
          >
            <Ship size={16} />
            Bill Of Lading
          </Button>
        )}
        {this.props.isShowSyncButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generateSync(e)}
          >
            <RefreshCw size={16} />
            Sync[SO]
          </Button>
        )}
        {this.props.isShowMailPackingButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.mailPacking(e)}
          >
            <MailCheck size={16} />
            MailPacking
          </Button>
        )}
        {this.props.isShowExcelPackingButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.excelPacking(e)}
          >
            <FileSpreadsheet size={16} />
            ExcelPacking
          </Button>
        )}
        {this.props.isShowShippingButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.shippingPickTicket(e)}
          >
            <Truck size={16} />
            Shipping
          </Button>
        )}
      </>
    );
  }
}
